"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ETL_EXTENSIONS = exports.DOCUMENT_EXTENSIONS = exports.ALL_EXTENSIONS = void 0;
var ALL_EXTENSIONS = exports.ALL_EXTENSIONS = ['xlsx', 'xls', 'jpg', 'png', 'txt', 'csv', 'json', 'pdf'];
var DOCUMENT_EXTENSIONS = exports.DOCUMENT_EXTENSIONS = ['xlsx', 'xls', 'jpg', 'png', 'pdf'];
var ETL_EXTENSIONS = exports.ETL_EXTENSIONS = ['xlsx', 'xls', 'txt', 'csv', 'json'];